import React from 'react';

function CheckboxIcon2({ color = "#e1e1e1", size = 28, number = 0 }) {
  const isCompleted = color === "#5CB85C";
  return (
    <div style={{
      width: size,
      height: size,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: isCompleted
        ? 'linear-gradient(135deg, #509540, #3d7a30)'
        : '#1C2634',
      borderRadius: '50%',
      color: '#fff',
      fontSize: size * 0.5,
      fontWeight: 800,
      fontFamily: "'Poppins', sans-serif",
      boxShadow: isCompleted
        ? '0 4px 10px rgba(80,149,64,0.35)'
        : '0 3px 8px rgba(28,38,52,0.25)',
      border: '2px solid #fff',
    }}>
      {number}
    </div>
  );
}

export default CheckboxIcon2;
